import { m } from "framer-motion";

import EmailPill from "./EmailPill";

const stagger = {
	hidden: { opacity: 0 },
	show: {
		opacity: 1,
		transition: { staggerChildren: 0.12, delayChildren: 0.1 },
	},
};

const fadeUp = {
	hidden: { opacity: 0, y: 20 },
	show: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
	},
};

function HeroEmailMockup() {
	return (
		<div className="bg-white rounded-xl shadow-2xl shadow-blue-950/30 overflow-hidden max-w-[380px] ml-auto">
			{/* Toolbar */}
			<div className="flex items-center gap-2 px-4 py-2.5 bg-gray-200 border-b border-gray-300/60">
				<div className="flex gap-1.5">
					<div className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
					<div className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
					<div className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
				</div>
				<span className="text-[11px] text-gray-400 font-inter ml-1">New Message</span>
			</div>
			{/* Email fields */}
			<div className="p-5 font-inter">
				<div className="space-y-2.5 text-[13px] mb-4">
					<div className="flex gap-2">
						<span className="text-gray-400 w-12 shrink-0">To</span>
						<span className="text-blue-600 font-medium">promotejobs@dproz.com</span>
					</div>
					<div className="flex gap-2 pb-3 border-b border-gray-100">
						<span className="text-gray-400 w-12 shrink-0">Subject</span>
						<span className="text-gray-800">Hiring: Senior Sales Manager</span>
					</div>
				</div>
				<div className="text-[13px] text-gray-500 space-y-2 leading-relaxed mb-4">
					<p>Hello Dproz,</p>
					<p>
						We're looking for a Senior Sales Manager to join our team in Dar es Salaam. Please find the job description
						attached.
					</p>
					<p>
						Best regards,
						<br />
						Sarah K. — Titan Manufacturing
					</p>
				</div>
				<div className="flex items-center justify-between pt-3 border-t border-gray-100">
					<div className="flex items-center gap-1.5 text-gray-400 text-[11px]">
						<svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
							/>
						</svg>
						JD_Sales_Manager.pdf
					</div>
					<div className="bg-blue-600 text-white text-xs px-3.5 py-1.5 rounded-lg font-medium flex items-center gap-1.5">
						<svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
						</svg>
						Send
					</div>
				</div>
			</div>
		</div>
	);
}

function HeroSection() {
	return (
		<section className="px-2 sm:px-4 pt-4">
			<div className="relative bg-blue-800 rounded-2xl overflow-hidden">
				{/* Layered background for depth */}
				<div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(37,99,235,0.25)_0%,transparent_60%)]" />
				<div
					className="absolute inset-0 opacity-[0.03]"
					style={{
						backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
						backgroundSize: "32px 32px",
					}}
				/>

				<div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-16 sm:pt-24 pb-16 sm:pb-24">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
						{/* Text column */}
						<m.div className="text-center lg:text-left" variants={stagger} initial="hidden" animate="show">
							<m.h1 className="mb-6" variants={fadeUp}>
								<span className="block font-plus-jakarta text-[clamp(1.25rem,3vw,1.75rem)] font-bold text-white/60 leading-tight tracking-tight mb-2">
									Hiring Should Be Simple.
								</span>
								<span className="block font-plus-jakarta text-[clamp(2.25rem,6.5vw,4.5rem)] font-extrabold text-white leading-[1.02] tracking-tight">
									Just Email the Job.
								</span>
							</m.h1>

							<m.p
								className="font-inter text-base sm:text-lg text-white/70 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0"
								variants={fadeUp}
							>
								No accounts to create. No forms to fill out. Forward us the job description — we handle the rest.
							</m.p>

							<m.div className="flex justify-center lg:justify-start" variants={fadeUp}>
								<EmailPill />
							</m.div>
						</m.div>

						{/* Email mockup illustration */}
						<m.div
							className="hidden lg:block"
							initial={{ opacity: 0, y: 30 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{
								duration: 0.7,
								delay: 0.4,
								ease: [0.22, 1, 0.36, 1],
							}}
						>
							<div className="rotate-1">
								<HeroEmailMockup />
							</div>
						</m.div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default HeroSection;
